import React from 'react';
import classnames from 'classnames';
import { TierPresentationsB } from '../../../../constants/TierPresentations';
import {
	CURRENT,
	ONBOARDING_TIER_OPTIONS_PROMO_PERIOD_PROMO,
	BLACK_FRIDAY,
} from '../../../../constants/Copy';
import { TIER_IDS } from '../../../../constants/Tiers';
import TierList from './TierList';

import './TierDescriptionB.scss';

const TierDescriptionB = ({
	tierId,
	pricing,
	discountedPrice,
	current,
	selected,
	onClick,
	isBlackFriday,
}) => {
	const tierPresentation = TierPresentationsB[tierId];
	const testId = `tierdetails-container--${tierId}`;

	const handleKeyDown = (event) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			onClick?.(tierId);
		}
	};

	return (
		<article
			className={classnames(`tierdescriptionB ${tierId}`, {
				['tierdescriptionB--selected']: selected,
			})}
			key={tierId}
			onClick={() => onClick?.(tierId)}
			onKeyDown={handleKeyDown}
			tabIndex="0"
			role="button"
			aria-pressed={selected}
			data-test={testId}
		>
			{current && (
				<span
					className={classnames('tierdescriptionB__current-label', {
						['tierdescriptionB__current-label--selected']: selected,
					})}
				>
					{CURRENT}
					<span> pakket</span>
				</span>
			)}
			{isBlackFriday && (
				<span
					className={classnames('tierdescriptionB__current-label promo-deal', {
						['tierdescriptionB__current-label--selected promo-deal--selected']: selected,
					})}
				>
					{BLACK_FRIDAY.TIER_LABEL}
					<span
						className={classnames('', {
							['promo-deal--label']: isBlackFriday,
						})}
					>
						{' '}
						{BLACK_FRIDAY.TIER_LABEL_DEAL}
					</span>
				</span>
			)}
			<div
				className={classnames('tierdescriptionB__header', {
					['tierdescriptionB__header--selected']: selected,
				})}
			>
				<div
					className={classnames('tierdescriptionB__radio', {
						['tierdescriptionB__radio--selected']: selected,
					})}
				></div>
				<div className="tierdescriptionB__headerContentWrapper">
					<div
						className={classnames('tierdescriptionB__titleWrapper', {
							['tierdescriptionB__titleWrapper--no-label']: !tierPresentation.label,
						})}
					>
						<h2 className="tierdescriptionB__title" data-test="tierdetails-title">
							{tierPresentation.title}
						</h2>
						{tierPresentation.label && (
							<span
								className={classnames('tierdescriptionB__label', {
									['tierdescriptionB__label--selected']: selected,
								})}
								data-test="tierdetails-current"
							>
								{tierPresentation.label}
							</span>
						)}
					</div>
					{isBlackFriday && (
						<span
							className={classnames('tierdescriptionB__header-period', {
								['tierdescriptionB__header-period--selected']: selected,
							})}
						>
							{BLACK_FRIDAY.TIER_PERIOD}
						</span>
					)}
					<div className="tierdescriptionB__headerPricing">
						<span
							className={classnames('tierdescriptionB__headerPricingPrice', {
								['tierdescriptionB__headerPricingPrice--discountedPrice']: discountedPrice,
							})}
						>
							{tierId === TIER_IDS.FREE
								? ONBOARDING_TIER_OPTIONS_PROMO_PERIOD_PROMO
								: `€${pricing}`}
						</span>
						{discountedPrice && (
							<span className="tierdescriptionB__headerPricingPrice">€{discountedPrice}</span>
						)}
						{tierId !== TIER_IDS.FREE && (
							<span className="tierdescriptionB__headerPricingPeriod">/ maand</span>
						)}
					</div>
				</div>
			</div>
			<div className="tierdescriptionB__features" data-test="tierdescriptionB-features">
				<TierList tierFeatures={tierPresentation} />
			</div>
		</article>
	);
};

export default TierDescriptionB;
